import { runtimeConfig } from 'config/runtimeConfig';

export const CONTACTS = {
  instagram: '#',
  facebook: '#',
  vk: '#',
  telegram: '#',
  whatsapp: '#',
  odnoklassniki: '#',
};

export const LINKS = {
  header: {
    all: '/',
    actions: '#',
    sushi: '#',
    pizza: '#',
    burgers: '#',
    fastfood: '#',
    shashlik: '#',
    deserts: '#',
    healthyfood: '#',
  },

  footer: {
    forRestaurants: '#',
    forCouriers: '#',
    forCompanies: '#',
    actions: '#',
    aboutUs: '#',
  },
};

export const APPS = {
  appStore: '#',
  googlePlay: '#',
};

export const CookiesLifeTime: {
  accessToken: number;
  sessionId: number;
} = {
  accessToken: 365 * 3 * 60 * 60 * 24,
  sessionId: 365 * 3 * 60 * 60 * 24,
};
export const Timers = {};

export const MESSAGE_TYPES = {
  INIT_FIREBASE: 'INIT_FIREBASE',
  INIT_TRANSLATIONS: 'INIT_TRANSLATIONS',
} as const;

export const LOAD_LIMIT: number | string = runtimeConfig.LOAD_LIMIT;

/*
 * Чтобы высчитать скидку выгоду в $, в моменте поля в api не было
 * следует получать их динамически и кешировать
 */
export const PLACEMENT_STANDARD_PRICE = 31;
export const PLACEMENT_OPTIMUM_PRICE = 92;
export const PLACEMENT_PREMIUM_PRICE = 230;
export const CV_CONTACT_OPEN_PRICE = 12;
export const DEFAULT_CV_CONTACT_OFFERS = [1, 10, 20, 30, 50, 90];

export const TELEGRAM_CHANNEL_RU_LINK = 'https://t.me/arbihunter';
export const TELEGRAM_SUPPORT_LINK = 'https://t.me/arbihunter_support';
